// // src/components/Hero.js
// import React from "react";
// import Nav from "../general/NavBar.jsx";
// import { HashLink as Link } from "react-router-hash-link";

// const Hero = () => {
//   return (
//     <section className="hero" id="hero">
//       <div className="hero-bg">
//         <img src="/favicon.ico" alt="logo" />
//       </div>
//       <Nav />

//       <div className="hero-content">
//         <h1>
//           DÉPLOYEZ VOTRE <span>POTENTIEL.</span>
//           <br />
//           FORMEZ VOTRE <span>AVENIR.</span>
//         </h1>

//         <Link to="/contact" className="hero-btn">
//           Contactez-nous !
//         </Link>
//       </div>

//       <div className="hero-blocs">
//         <div className="bloc pink">
//           <h3>
//             DU SÉRIEUX
//             <br />
//             DANS LA PAPERASSE
//           </h3>
//           <p>
//             Certifiées & finançables
//             <br />
//             par CPF, OPCO, etc.
//           </p>
//         </div>
//         <div className="bloc yellow">
//           <h3>
//             DES SKILLS POUR AUJOURD’HUI
//             <br />
//             (ET DEMAIN)
//           </h3>
//           <p>Digital, réseaux sociaux, communication, langues...</p>
//         </div>
//         <div className="bloc blue">
//           <h3>
//             APPRENDRE SANS
//             <br />
//             S’ENDORMIR
//           </h3>
//           <p>
//             Formations utiles
//             <br />
//             et (presque) sans PowerPoint ennuyeux
//           </p>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Hero;

// src/components/Hero.js
import React from "react";
import Nav from "../general/NavBar.jsx";
import { HashLink as Link } from "react-router-hash-link";

const Hero = () => {
  return (
    <section className="hero" id="hero">
      <div className="hero-bg">
        <img src="/favicon.ico" alt="logo" />
      </div>
      <Nav />

      <div className="hero-content">
        <h1>
          DÉPLOYEZ VOTRE <span>POTENTIEL.</span>
          <br />
          FORMEZ VOTRE <span>AVENIR.</span>
        </h1>

        <Link to="/contact" className="hero-btn">
          Contactez-nous !
        </Link>
      </div>

      <div className="hero-blocs">
        <div className="bloc pink">
          <h3>
            DU SÉRIEUX
            <br />
            DANS LA PAPERASSE
          </h3>
          <p>
            Démarches simplifiées
            <br />& suivi administratif complet
          </p>
        </div>
        <div className="bloc yellow">
          <h3>
            DES SKILLS POUR AUJOURD’HUI
            <br />
            (ET DEMAIN)
          </h3>
          <p>Digital, réseaux sociaux, communication, langues...</p>
        </div>
        <div className="bloc blue">
          <h3>
            APPRENDRE SANS
            <br />
            S’ENDORMIR
          </h3>
          <p>
            Formations utiles
            <br />
            et (presque) sans PowerPoint ennuyeux
          </p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
